import type { IWidgetConfig } from "../shared/session/interfaces/session";

export type AmountAnchor = "send" | "receive";

/**
 * Resolves which leg the link's pinned `amount` refers to. Minted request links
 * set `amountAnchor: 'receive'`; legacy links infer receive when `requestId`
 * is present.
 */
/** True when the payer may edit amount in Transfer (default when flag omitted). */
export function isAmountEditable(
  config: Pick<IWidgetConfig, "allowAmountEdit"> | undefined,
): boolean {
  return config?.allowAmountEdit === true;
}

export function resolveAmountAnchor(
  config: Pick<IWidgetConfig, "amountAnchor" | "requestId"> | undefined,
): AmountAnchor {
  if (config?.amountAnchor === "receive" || config?.amountAnchor === "send") {
    return config.amountAnchor;
  }
  return config?.requestId ? "receive" : "send";
}

/** Currency code used to label the pinned request amount for display. */
export function requestedAmountCurrency(
  config:
    | Pick<IWidgetConfig, "sourceCurrency" | "destinationCurrency">
    | undefined,
  anchor: AmountAnchor,
): string {
  if (anchor === "receive") {
    return config?.destinationCurrency ?? "USD";
  }
  return config?.sourceCurrency ?? "USD";
}
